import constants from '../constants/index';

const ParticipantActions = {
  selectParticipantGroup: function(type, group, selected) {
    return {
      type: constants.SELECT_PARTICIPANTS_GROUP,
      payload: {
        type: type,
        group: group,
        selected: selected
      }
    };
  }
};

export default ParticipantActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/participant_actions.js
 **/